import Valkyrie from "@sippy-platform/valkyrie";

import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function NavigationItem({ title, icon, ...props }) {
  return (
    <ListItem disablePadding>
      <ListItemButton {...props}>
        <ListItemIcon>
          <Valkyrie icon={icon} />
        </ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
}

NavigationItem.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.object,
};

export default NavigationItem;
